import { Card, Form, Input, InputNumber, Select, Typography } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { IProduct } from 'interfaces/products';
import { IProductCategory } from 'interfaces/product_categories';
import {
  KINDS,
  getConfigFields,
  translateKind
} from 'services/offers/campaigns';
import { PageHeader } from 'components/professor_area/PageHeader';
import { TOfferCampaign, TOfferCampaignKind } from 'interfaces/offers';
import { useForm, useSelect } from '@refinedev/antd';
import { useState } from 'react';

const { Title } = Typography;

export const OfferCampaignCreate = () => {
  const { formProps, saveButtonProps } = useForm<TOfferCampaign>();
  const [kindKey, setKindKey] = useState<TOfferCampaignKind | null>(null);
  const configFields = kindKey ? getConfigFields(kindKey) : new Map();

  const { selectProps: productSelectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  const { selectProps: productCategoriesSelectProps } =
    useSelect<IProductCategory>({
      resource: 'products/categories',
      optionLabel: 'name',
      optionValue: 'id',

      onSearch: value => [
        {
          field: 'filter[by_name]',
          operator: 'eq',
          value
        }
      ],

      pagination: {
        mode: 'server'
      }
    });

  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Criar campanha" icon={EcommerceIconComponent} />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Tipo"
            name="kind"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select onChange={setKindKey}>
              {KINDS.map(kind => (
                <Select.Option key={kind}>{translateKind(kind)}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          {configFields && (
            <>
              <Title level={5}>Configurações</Title>
              {[...configFields].map(([key, configField]) => (
                <Form.Item
                  key={key}
                  label={configField.name}
                  name={['config', key]}
                >
                  {configField.input === 'price' ? (
                    <InputNumber addonBefore="R$" precision={2} />
                  ) : configField.input === 'percentage' ? (
                    <InputNumber addonAfter="%" precision={0} />
                  ) : configField.input === 'product_ids' ? (
                    <Select {...productSelectProps} mode="multiple" />
                  ) : configField.input === 'category_ids' ? (
                    <Select {...productCategoriesSelectProps} mode="multiple" />
                  ) : (
                    <Input />
                  )}
                </Form.Item>
              ))}
            </>
          )}
        </Form>
      </Card>
    </CreateLayout>
  );
};
